// Import the functions you need from the SDKs you need
import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth, setPersistence, browserLocalPersistence } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC7ukz_5OVZDOsck45jZ4yRt8MMesc_VgQ",
  authDomain: "lexpay-1b89c.firebaseapp.com",
  projectId: "lexpay-1b89c",
  storageBucket: "lexpay-1b89c.firebasestorage.app",
  messagingSenderId: "512268035986",
  appId: "1:512268035986:web:3500355a22c2df01a3034b",
  measurementId: "G-00N6SV508D"
};

// Initialize Firebase
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();
const auth = getAuth(app);

// Enable persistent authentication
setPersistence(auth, browserLocalPersistence)
  .catch((error) => {
    console.error('Error enabling persistence:', error);
  });

const db = getFirestore(app);
const storage = getStorage(app);

export { app, auth, db, storage };
